/**
 * @desc 保存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ChangeOrderDetailRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrderDetail/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
